import usePaginationLimit from './paginationLimitHook';
import { ListQuery } from '../api/apiTypes';
import { PaginationLimit, PaginationScreenKey } from '../services/paginationLimitService';

export interface StorePagination {
  limit: PaginationLimit;
  changePage: (page: number) => void;
  changeLimit: (limit: number) => void;
}

/** Page in the store query, page size per screen; a new page size resets to page 1. */
export default function useStorePagination<T>(
  screen: PaginationScreenKey,
  currentFilter: ListQuery<T>,
  setFilter: (query: ListQuery<T>) => void,
  defaultLimit?: PaginationLimit,
): StorePagination {
  const [limit, setLimit] = usePaginationLimit(screen, defaultLimit);

  const changePage = (page: number): void => {
    setFilter({ ...currentFilter, page });
  };

  const changeLimit = (value: number): void => {
    setLimit(value);
    changePage(1);
  };

  return { limit, changePage, changeLimit };
}
